import React from 'react'
import Alert from '../../components/Alert'
export default () => (
  <Alert />
)